export default "__VITE_ASSET__CMXcyy9f__"